import React, { useState } from "react";
import { useIntl } from "react-intl";
import { Download } from "@piiqtechnologies/svg-icons";
import { PeekIconButton, PeekTooltip, useTheme } from "@piiqtechnologies/ui-components";
import { AnalyticsArea, useTrackEvent } from "@hooks";
import { DownloadMode, DownloadScope } from "@constants/Export";
import { useExportContext } from "@stores/ExportContext";
import { DownloadReportDialog } from "@components/common/download-report-dialog";
import messages from "./messages.i18n";
const BUTTON_SIZE = "42px";
const SCOPE_COPY = {
    [DownloadScope.Portfolio]: {
        mode: DownloadMode.Bulk,
        scope: messages.portfolioScope,
        disabled: messages.portfolioDisabled,
    },
    [DownloadScope.Community]: {
        mode: DownloadMode.Single,
        scope: messages.communityScope,
        disabled: messages.communityDisabled,
    },
    [DownloadScope.Report]: { mode: DownloadMode.Single, scope: messages.reportScope, disabled: messages.reportDisabled },
};
export const DownloadReportButton = ({ scope, communities, communityIds, assessmentId, withOrganizationField = false, onOrganizationChange, communitiesLoading, disabled = false, }) => {
    const intl = useIntl();
    const theme = useTheme();
    const { startExport, isExporting } = useExportContext();
    const track = useTrackEvent();
    const [open, setOpen] = useState(false);
    const { mode, scope: scopeMessage, disabled: disabledMessage } = SCOPE_COPY[scope];
    const isDisabled = disabled || isExporting;
    const tooltip = intl.formatMessage(isExporting ? messages.exportInProgress : disabledMessage);
    const handleOpen = () => {
        track(AnalyticsArea.Export, "Modal Opened", { mode });
        setOpen(true);
    };
    const handleDownload = (payload) => startExport(payload);
    const button = (React.createElement(PeekIconButton, { "data-testid": "download-report-button", "aria-label": intl.formatMessage(messages.ariaLabel), bordered: false, disabled: isDisabled, onClick: handleOpen, sx: {
            height: BUTTON_SIZE,
            width: BUTTON_SIZE,
            minWidth: BUTTON_SIZE,
            borderRadius: theme.spacing(0.8),
            backgroundColor: "primary.main",
            color: "common.white",
            "&:hover": { backgroundColor: "secondary.main" },
        } },
        React.createElement(Download, { width: 18, height: 18, style: { color: "currentColor" } })));
    return (React.createElement(React.Fragment, null,
        isDisabled && tooltip ? (React.createElement(PeekTooltip, { title: tooltip, placement: "top" },
            React.createElement("span", null, button))) : (button),
        React.createElement(DownloadReportDialog, { open: open, onClose: () => setOpen(false), mode: mode, scopeLabel: intl.formatMessage(scopeMessage), communities: communities, communityIds: communityIds, assessmentId: assessmentId, withOrganizationField: withOrganizationField, onOrganizationChange: onOrganizationChange, communitiesLoading: communitiesLoading, onDownload: handleDownload })));
};
export default DownloadReportButton;
